import React from "react";

const EventInv = () => {
  return (
    <div className="biopanel">
      <div className="file-info">
        <div className="cell file-name">
          <i className="fa-solid fa-folder"> </i>
          projects {"> "}
          <i className="fa-solid fa-folder"> </i>
          eventInv
          <i class="fa-solid fa-x"></i>
        </div>
      </div>
      <div className="panel-content">eventInv</div>
    </div>
  );
};

export default EventInv;
